import { isFunction } from "lodash-es";
import React, { useCallback } from "react";
import { classnames } from "../../utils/text";

const CheckBox = ({
  // color = "secondary", // primary, secondary, success, danger, warning, info, light, dark
  style = {},
  disabled = false,
  checked,
  onChange,
  label,
  value,
  className,
  options,
}) => {
  const getChecked = useCallback(() => {
    return isFunction(checked) ? checked() : checked;
  }, [checked]);

  return (
    <div
      style={style}
      className={classnames('checkbox-wrap', className, { checked, disabled })}
    >
      <label>
        <input
          type="checkbox"
          checked={getChecked()}
          value={value}
          onChange={(e) => {
            onChange(!checked, value, e);
          }}
          disabled={disabled}
        />
        <span className="checkmark"></span>
        {label && <span className="checkbox-label">{label}</span>}
      </label>
    </div>
  );
};
export default CheckBox;
